import CloseIcon from "@mui/icons-material/Close";
import { Box, Checkbox, Chip, ListItemText } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useState } from "react";
import "./MultipleSelect.css";
import s from "./MultipleSelect.module.css";

type DropdownSelectProps = {
  data: { value: string; lable: string; disabled?: boolean }[];
  setValue: (value: string | string[]) => void;
  value: string | string[];
  multiplie: boolean;
  width?: string;
  lable?: string;
  checkBox?: boolean;
  height?: string;
  padding?: string;
  disabled?: boolean;
  placeholder?: string;
  bgColor?: string;
  border?: string;
  chip?: boolean;
  defaultValue?: string;
  lableTop?: string;
  margin?: string;
  resetBtn?: boolean;
  disableSortData?: boolean;
  ariaLabel?: string;
};

const MultipleSelect = ({
  data,
  setValue,
  value,
  multiplie,
  width,
  lable,
  checkBox,
  height,
  padding,
  disabled,
  placeholder,
  bgColor,
  border,
  chip,
  defaultValue,
  lableTop,
  margin,
  resetBtn,
  disableSortData,
  ariaLabel,
}: DropdownSelectProps) => {
  const [selectIsOpen, setSelectIsOpen] = useState(false);
  const inputStyle = {
    border: "none",
    "&:focus": {
      /*  borderColor: "#3FB083", */
    },
  };

  function truncateString(str: string, maxLength: number) {
    if (str.length > maxLength) {
      return str.slice(0, maxLength) + "...";
    }
    return str;
  }

  const priorityValues = ["initial", "other", "notAccredited"];

  const sortedData = [...data].sort((a, b) => {
    if (!a.disabled && b.disabled) return -1;
    if (a.disabled && !b.disabled) return 1;

    const aIsPriority = priorityValues.includes(a.value);
    const bIsPriority = priorityValues.includes(b.value);

    if (aIsPriority && !bIsPriority) return 1; // приоритет внизу
    if (!aIsPriority && bIsPriority) return -1;

    return a.lable.localeCompare(b.lable);
  });

  return (
    <div
      style={{
        width: width ? width : "100%",
        margin: margin ?? "0",
        position: "relative",
      }}
      className={s.container}
    >
      <FormControl
        variant="outlined"
        sx={{ minWidth: 120, width: "100%", margin: 0 }}
      >
        <InputLabel
          id={
            chip
              ? "demo-multiple-chip-label"
              : checkBox
                ? "demo-multiple-checkbox-label"
                : "demo-multiple-name-label"
          }
          shrink={selectIsOpen || (value && value.length) ? true : false}
          style={{
            color: "white",
            top:
              selectIsOpen || (value && value.length)
                ? "-7px"
                : (lableTop ?? "-5px"),
          }}
        >
          {lable}
        </InputLabel>

        <Select
          multiple={multiplie}
          disabled={disabled ? disabled : false}
          color="success"
          onOpen={() => setSelectIsOpen(true)}
          onClose={() => setSelectIsOpen(false)}
          placeholder={placeholder ?? ""}
          style={{
            borderRadius: "20px",
            /* backgroundColor: "#313131", */
            borderColor: "red",
            ...inputStyle,
          }}
          labelId={
            chip
              ? "demo-multiple-chip-label"
              : checkBox
                ? "demo-multiple-checkbox-label"
                : "demo-multiple-name-label"
          }
          id={
            chip
              ? "demo-multiple-chip"
              : checkBox
                ? "demo-multiple-checkbox"
                : "demo-multiple-name"
          }
          //@ts-expect-error
          value={value}
          defaultValue={defaultValue ? [defaultValue] : undefined}
          renderValue={
            chip && data && data.length
              ? (selected: string[]) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        sx={{ color: "white" }}
                        label={
                          data.find((el) => el.value === value)
                            ? truncateString(
                                data.find((el) => el.value === value)!.lable,
                                selected.length > 1 ? 10 : 100,
                              )
                            : ""
                        }
                      />
                    ))}
                  </Box>
                )
              : checkBox
                ? (selected: string[]) =>
                    selected
                      .map(
                        (item) => data.find((el) => item === el.value)?.lable,
                      )
                      .join(", ")
                : undefined
          }
          onChange={(e) => {
            setValue(e.target.value);
          }}
          inputProps={{
            style: {
              ...inputStyle,
            },
          }}
          SelectDisplayProps={{
            style: {
              borderRadius: "20px",
              backgroundColor: bgColor ?? "rgb(46, 46, 46)",
              border: border ?? "none",
              height: height ? height : "auto",
              padding: padding ? padding : "10px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              paddingInline: "20px",
              color: "white",
            },
            "aria-label": ariaLabel,
          }}
          MenuProps={{
            style: {
              borderRadius: "20px",
              marginTop: "0px",
              maxHeight: "300px",
            },
          }}
        >
          {(disableSortData ? data : sortedData).map((item, index) =>
            checkBox ? (
              <MenuItem
                key={item.lable}
                value={item.value}
                disabled={item.disabled}
                className="multi-select-menu"
                sx={{
                  opacity: item.disabled ? 0.5 : 1,
                  "&.Mui-disabled": {
                    pointerEvents: "none",
                    color: "gray",
                  },
                }}
              >
                <Checkbox
                  checked={value.indexOf(item.value) > -1}
                  disabled={item.disabled}
                />
                <ListItemText primary={item.lable} />
              </MenuItem>
            ) : (
              <MenuItem
                value={item.value}
                key={index}
                disabled={item.disabled}
                className="multi-select-menu"
                sx={{
                  opacity: item.disabled ? 0.5 : 1,
                  "&.Mui-disabled": {
                    pointerEvents: "none",
                    color: "gray",
                  },
                }}
              >
                {item.lable}
              </MenuItem>
            ),
          )}
        </Select>
      </FormControl>
      {resetBtn &&
        value &&
        (Array.isArray(value) ? value.length > 0 : true) && (
          <CloseIcon
            onClick={() => setValue(multiplie ? [] : "")}
            sx={{
              position: "absolute",
              right: "30px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "white",
              zIndex: 2,
            }}
          />
        )}
    </div>
  );
};

export default MultipleSelect;
